/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
export var defaultCustomComponentsContextValue = {
  FormHeaderComponent: function FormHeaderComponent() {
    return null;
  },
  ReturnButtonComponent: function ReturnButtonComponent() {
    return null;
  },
  ProgressBarComponent: function ProgressBarComponent() {
    return null;
  },
  QuestionLayoutComponent: function QuestionLayoutComponent() {
    return null;
  },
  WidgetLayoutComponent: function WidgetLayoutComponent() {
    return null;
  }
};
export var customComponentsContextObj = /*#__PURE__*/React.createContext(defaultCustomComponentsContextValue);
export var CustomComponentsContextProvider = customComponentsContextObj.Provider;